export default "__VITE_ASSET__DzwCGAuY__"